"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MessageFilledIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M.89 0C.035 0-.327 1.119.356 1.646L4.05 4.5l6.356-1.976-4.868 4.47 1.01 6.242c.142.88 1.3 1.05 1.675.246l5.688-12.17C14.195.703 13.765 0 13.111 0H.89z"
  })))
});
MessageFilledIcon.displayName = 'MessageFilledIcon';
var _default = exports.default = MessageFilledIcon;